/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {
  FETCH_USER_DATA_REQUEST,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
  FETCH_ACTIVE_USERS_SUCCESS,
  FETCH_PENDING_USERS_SUCCESS,
  FETCH_DEACTIVATED_USERS_SUCCESS,
  FETCH_ACTIVE_USERS_COMPANIES,
  FETCH_ACTIVE_USERS_DOMAIN_COMPANIES,
  FETCH_USER_DATA_COUNT,
  FETCH_USER_DATA_COUNT_REQUEST,
} from "./GlobalAdminUsersTypes";

const initialState = {
  loading: false,
  countsLoading: true,
  activeUsersData: {},
  activeUsersDataCount: 0,
  requestUsersData: {},
  requestUsersDataCount: 0,
  deactivatedUsersData: {},
  deactivatedUsersDataCount: 0,
  domains: [],
  companies: [],
  oem_admin_roles: [],
  error: "",
};

const globalAdminUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_ACTIVE_USERS_SUCCESS:
    case FETCH_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        activeUsersData: action.payload,
        error: "",
      };
    case FETCH_PENDING_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        requestUsersData: action.payload,
        // Don't update count from filtered data - only from FETCH_USER_DATA_COUNT
        error: "",
      };
    case FETCH_DEACTIVATED_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        deactivatedUsersData: action.payload,
        // Don't update count from filtered data - only from FETCH_USER_DATA_COUNT
        error: "",
      };

    case FETCH_USER_DATA_COUNT_REQUEST:
      return {
        ...state,
        countsLoading: true,
      };

    case FETCH_USER_DATA_COUNT:
      return {
        ...state,
        countsLoading: false,
        activeUsersDataCount: action.payload.activeUsersDataCount,
        requestUsersDataCount: action.payload.requestUsersDataCount,
        deactivatedUsersDataCount: action.payload.deactivatedUsersDataCount,
        error: "",
      };

    case FETCH_ACTIVE_USERS_DOMAIN_COMPANIES:
      return {
        ...state,
        loading: false,
        domains: action.payload.domains,
        companies: action.payload.companies,
        oem_admin_roles: action.payload.oem_admin_roles,
        error: "",
      };

    case FETCH_ACTIVE_USERS_COMPANIES:
      return {
        ...state,
        loading: false,
        companies: action.payload,
        error: "",
      };

    case FETCH_USER_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default globalAdminUsersReducer;
